<template>
  <div class="page-header-index-wide">
    <a-card
      :bordered="false"
      :loading="loading"
    >
      <from>
        <div style=" background-color:rgba ">
          <a-tabs
            defaultActiveKey="1"
            :tabPosition="mode"
            @change="callback"
          >
            <a-tab-pane
              :tab="item.type"
              v-for="item in datatype"
              :key="item.typeId"
              :loading="loading"
            >
              <!-- 判断会员 -->
              <div style="position: relative; width: 100%;" v-if="userInfo.vipType==='1'">
                <div
                  class="news_item"
                  style="float:left; "
                  v-for="(items, index) in data"
                  :key="index"
                >
                  <a-card hoverable style="width: 250px" @click="routerTo(items.id,items.typeId)" >
                    <img
                      style="width: 248px;height:150px"
                      alt="example"
                      :src="items.culumPhoto"
                      slot="cover"
                    />
                    <template
                      class="ant-card-actions"
                      slot="actions"
                    >
                      <span v-if="items.section=='1'">小学</span>
                      <span v-if="items.section=='2'">初中</span>
                      <span v-if="items.section=='3'">高中</span>

                      <span
                        @click="routerTo(items.id,items.typeId)"
                        style="color:#FFC000;"
                      >学习>></span>

                    </template>
                    <a-card-meta style="height:70px" :title="items.name" >
                      <template slot="description">
                        <ellipsis :length="70" tooltip >
                          {{ items.culumText }}
                        </ellipsis>
                      </template>
                    </a-card-meta>

                  </a-card>
                </div>
              </div>
              <div style="position: relative; width: 100%;" v-else>
                <div class="news_item" style="float:left; " v-for="(items, index) in data" :key="index" >
                  <a-card hoverable style="width: 250px" @click="index == 0 ? routerTo(items.id,items.typeId) : changeByCarg()">
                    <img style="width: 248px;height:150px" alt="example" :src="items.culumPhoto" slot="cover" />
                    <template class="ant-card-actions" slot="actions" >
                      <span v-if="items.section=='1'">小学</span>
                      <span v-if="items.section=='2'">初中</span>
                      <span v-if="items.section=='3'">高中</span>

                      <span style="color:#FFC000;" >学习>></span>

                    </template>
                    <a-card-meta style="height:70px" :title="items.name" >
                      <template slot="description">
                        <ellipsis :length="70" tooltip >
                          {{ items.culumText }}
                        </ellipsis>
                      </template>
                    </a-card-meta>
                  </a-card>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </from>
    </a-card>
  </div>
</template>
<script>
import { getCulumList, getTypeList } from '@/api/datum/IncreaseCulum'
import Ellipsis from '@/components/Ellipsis'
import { mapGetters } from 'vuex'
export default {
  name: 'ImproveCourse',
  components: {
    Ellipsis
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  data () {
    return {
      mode: 'top',
      data: {},
      datatype: {},
      loading: true
    }
  },
  created () {
    this.getType()
  },
  methods: {
    // 非会员跳转购买云卡
    changeByCarg () {
      this.$confirm({
        title: '购买云卡，升级解锁全部资源？',
        // content: '退出后将保存做题进度',
        okText: '升级',
        cancelText: '取消',
        okButtonProps: {
          on: {
            click: this.clickHandler
          }
        }
      })
    },
    clickHandler () {
      this.$router.push({ path: '/cloudCard' })
    },
    getType () {
      getTypeList().then(res => {
        this.datatype = res.result
        getCulumList(this.datatype[0].typeId).then(res => {
          this.data = res.result
        })
        this.loading = false
      })
    },
    callback (key) {
      this.loading = true
      getCulumList(key).then(res => {
        this.data = res.result
      })
      this.loading = false
    },
    routerTo (id, typeId) {
      localStorage.setItem('courseId', id)
      localStorage.setItem('typeId', typeId)
      this.$router.push({ name: 'CourseVideo' })
    }
  }
}
</script>
<style>
.news_box {
  background-color: #fff;
}
.news_item {
  top: 0;
  left: 0;
  padding: 5px;
  margin: 10px;
  width: 23%;
  position: relative;
}
</style>
